import { _ as _inherits, a as _classCallCheck, b as _callSuper, c as _assertThisInitialized, d as _createClass } from '../../dist/inherits-8fbdedb5.esm.js';
import { EventEmitter } from 'events';

/**
 * Util type to represent maps of typed elements, but implemented with
 * JavaScript objects.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

/**
 * Returns a type similar to T, but with the K set of properties of the type
 * T *required*, and the rest optional.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

/**
 * Custom event emitter types.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

var TypedEventEmitter = /*#__PURE__*/function (_ref) {
  _inherits(TypedEventEmitter, _ref);
  function TypedEventEmitter() {
    var _this;
    _classCallCheck(this, TypedEventEmitter);
    _this = _callSuper(this, TypedEventEmitter);
    _this.rawEmitter = _assertThisInitialized(_this);
    return _this;
  }
  return _createClass(TypedEventEmitter);
}(EventEmitter);

/**
 * Event types.
 */

/**
 * Export various other types:
 */

export { TypedEventEmitter };
